"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_dom_1 = tslib_1.__importDefault(require("react-dom"));
const react_use_1 = require("react-use");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.Portal = ({ elementID, children, mode, hideOverflow = false, }) => {
    const [loaded, toggleLoaded] = react_use_1.useToggle(false);
    const portal = react_1.useRef(null);
    react_1.useEffect(() => {
        portal.current = document.getElementById(elementID);
    }, [elementID]);
    react_use_1.useInterval(() => {
        portal.current = document.getElementById(elementID);
    }, 1000);
    // DOM
    const el = react_1.useRef();
    const c = classnames_1.default('class', 'flex-full-col', hideOverflow && 'overflow-hidden');
    react_1.useEffect(() => {
        el.current = document.createElement('div');
        if (c) {
            el.current.setAttribute('class', c);
        }
        return () => {
            if (el.current && el.current.parentElement) {
                el.current.parentElement.removeChild(el.current);
            }
        };
    }, [c]);
    react_1.useEffect(() => {
        if (!loaded && portal.current && el.current) {
            if (mode === 'prepend') {
                portal.current.insertAdjacentElement('afterbegin', el.current);
            }
            if (mode === 'replace') {
                portal.current.innerHTML = '';
            }
            if (mode !== 'prepend') {
                portal.current.appendChild(el.current);
            }
            toggleLoaded(true);
        }
    }, [el, portal, loaded, mode, toggleLoaded]);
    react_use_1.useUnmount(() => {
        if (el.current && el.current.parentElement) {
            el.current.parentElement.removeChild(el.current);
        }
    });
    if (!el.current || !portal.current) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_dom_1.default.createPortal(children, el.current);
};
//# sourceMappingURL=Portal.js.map